import React from "react";

import {
  Badge,
  Modal,
  TextField,
  Typography,
  IconWrapper,
} from "@king-ict/eupisi-ui/components";
import { ReactComponent as ContactIcon } from "@king-ict/eupisi-ui/components/Icon/Contact.svg";
import { ReactComponent as CriterionIcon } from "@king-ict/eupisi-ui/components/Icon/Criterion.svg";
import { ReactComponent as InstitutionIcon } from "@king-ict/eupisi-ui/components/Icon/Institution.svg";
import { getInstitutionDisplayNameAndTown } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InstitutionDetails from "../../models/Institution/InstitutionDetails";
import style from "./InstitutionDetailsModal.module.scss";

interface Props {
  institutionDetails: InstitutionDetails;
  detailsModalOpen: boolean;
  handlerCloseDetails: () => void;
}
export const InstitutionDetailsModal: React.FC<Props> = ({
  institutionDetails,
  detailsModalOpen,
  handlerCloseDetails,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={getInstitutionDisplayNameAndTown(
        institutionDetails.name,
        institutionDetails.town
      )}
      open={detailsModalOpen}
      variant="big"
      onClose={handlerCloseDetails}
    >
      <div>
        <Row>
          <Col md={12} className={style.subTitle}>
            <IconWrapper color="body-color">
              <InstitutionIcon />
            </IconWrapper>
            <Typography variant="mediumBold" component="h3">
              {t("institutionSearchPage.about")}
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Typography color="light">
              {institutionDetails.description}
            </Typography>
          </Col>
        </Row>
        <Row className={style.detailsSubTitleRow}>
          <Col md={12} className={style.subTitle}>
            <IconWrapper color="body-color">
              <CriterionIcon />
            </IconWrapper>
            <Typography variant="mediumBold" component="h3">
              {t("institutionSearchPage.criterion")}
            </Typography>
          </Col>
        </Row>
        <Row>
          {institutionDetails.criteria &&
            institutionDetails.criteria.map((criterion, index) => {
              return (
                <Col
                  md={12}
                  key={`${institutionDetails.pedagogicalYearInstitutionId}_criterion_${index}`}
                  className={style.criterion}
                >
                  {!criterion.isDirectEnrollment ? (
                    <Badge
                      value={criterion.points}
                      color="success"
                      variant="small"
                    ></Badge>
                  ) : (
                    ""
                  )}
                  <Typography variant="baseBold" color="light">
                    {criterion.name}
                    {criterion.isDirectEnrollment
                      ? " (" + t("criteriaStep.directEnrollment") + ")"
                      : ""}
                  </Typography>
                </Col>
              );
            })}
        </Row>
        <Row className={style.detailsSubTitleRow}>
          <Col md={12} className={style.subTitle}>
            <IconWrapper color="body-color">
              <ContactIcon />
            </IconWrapper>
            <Typography variant="mediumBold" component="h3">
              {t("institutionSearchPage.contact")}
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <TextField
              plaintext
              bold
              label={t("common.phone")}
              value={institutionDetails.phone}
            />
          </Col>
          <Col md={4}>
            <TextField
              plaintext
              bold
              label={t("common.address")}
              value={institutionDetails.address}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <TextField
              plaintext
              bold
              color="primary"
              label={t("common.email")}
              value={institutionDetails.email}
              type="email"
            />
          </Col>
          <Col md={4}>
            <TextField
              plaintext
              bold
              color="primary"
              label={t("common.webAddress")}
              value={institutionDetails.webAddress}
              type="url"
            />
          </Col>
        </Row>
        <Row className={style.detailsSubTitleRow}>
          <Col md={12} className={style.subTitle}>
            <InstitutionIcon />
            <Typography variant="mediumBold" component="h3">
              {t("institutionSearchPage.details")}
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <TextField
              plaintext
              bold
              label={t("institutionSearchPage.founderType")}
              value={institutionDetails.founderType}
            />
          </Col>
          <Col md={4}>
            <TextField
              plaintext
              bold
              label={t("institutionSearchPage.institutionType")}
              value={institutionDetails.institutionType}
            />
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
